<div class="bg-white flex flex-col rounded-xl shadow-[0px_1px_2px_rgba(0,0,0,0.3),0px_2px_6px_2px_rgba(0,0,0,0.15)] p-4 m-1">
    <div class="flex items-center gap-1">
        <span *ngIf="label != ''" class="font-medium text-xl leading-6 tracking-normal text-[#212121]">{{label}}</span>
        <p *ngIf="sub_label != ''" class="text-[#666666] text-sm">{{sub_label}}</p>
    </div>
    <p *ngIf="description != ''" class="text-[#666666] text-sm mt-2">{{description}}</p>
    <div class="gap-4 grid grid-cols-1 md:grid-cols-3 mt-4">
        <ng-content></ng-content>
    </div>
</div>